const setDemands = (state, demands) => {
  Object.assign(state, { demands })
}

const updateDemands = (state, demands) => {
  Object.assign(state, { demands: [...state.demands, ...demands] })
}

const setActionRecommendations = (state, actionRecommendations) => {
  Object.assign(state, { actionRecommendations })
}

const setCurrentDemandDetails = (state, currentDemandDetails) => {
  Object.assign(state, { currentDemandDetails })
}

const setCurrentActionRecommendation = (state, currentActionRecommendation) => {
  Object.assign(state, { currentActionRecommendation })
}

const addCurrentDemandRecords = (state, currentDemandRecords) => {
  Object.assign(state, {
    currentDemandRecords: [
      ...state.currentDemandRecords,
      ...currentDemandRecords
    ]
  })
}

const setCurrentDemandRecords = (state, currentDemandRecords) => {
  Object.assign(state, {
    currentDemandRecords
  })
}

const setCurrentPagination = (state, data) => {
  Object.assign(state, {
    pagination: { ...state.pagination, ...data }
  })
}

const updateCurrentDemandDetails = (state, data) => {
  Object.assign(state, {
    currentDemandDetails: {
      ...state.currentDemandDetails,
      ...data
    }
  })
}

const setFiltersConfig = (state, filter) => {
  if (state.filtersConfig === null) {
    state.filtersConfig = {}
  }
  state.filtersConfig = filter
}

const clearFilters = state => {
  Object.assign(state, {
    filters: {}
  })
}

const clearFiltersConfig = state => {
  Object.assign(state, {
    filtersConfig: null
  })
}

const setPaginatedFilters = (state, filters) => {
  Object.assign(state, {
    pagination: { ...state.pagination, filters }
  })
}

const clearPaginatedFilters = state => {
  Object.assign(state, {
    pagination: { ...state.pagination, filters: {} }
  })
}

const setFilterByChannel = (state, channelId) => {
  if (!channelId) {
    Object.assign(state, {
      pagination: { ...state.pagination, filters: {} }
    })
    return
  }

  Object.assign(state, {
    pagination: { ...state.pagination, filters: { channelId } }
  })
}

export default {
  setDemands,
  updateDemands,
  setActionRecommendations,
  setFiltersConfig,
  clearFilters,
  clearFiltersConfig,
  updateCurrentDemandDetails,
  setCurrentDemandDetails,
  addCurrentDemandRecords,
  setCurrentDemandRecords,
  setCurrentPagination,
  setCurrentActionRecommendation,
  setPaginatedFilters,
  setFilterByChannel,
  clearPaginatedFilters
}
